import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BtnIconPosition } from '../../type/btnIconPosition.type';
import { ThemePalette } from '@angular/material/core';

@Component({
  selector: 'app-simple-input-with-icon',
  templateUrl: './simple-input-with-icon.component.html',
  styleUrls: ['./simple-input-with-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SimpleInputWithIconComponent {
  @Input('color') color: ThemePalette;
  @Input('icon') icon: string = 'favorite';
  @Input('iconPosition') iconPosition: BtnIconPosition = 'right';
  @Input('text') text: string = 'Placeholder text';
  @Input('placeholder') placeholder: string = 'Placeholder text';
}
